(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bibouche-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bibouche-univers')) {customElements.define('bibouche-univers',class extends HTMLElement {connectedCallback(){this.controller?.abort();this.controller=new AbortController();const filters=this.querySelector('[data-bb-filters]');if(!filters)return;filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('button[data-bb-age]');if(!button||!filters.contains(button))return;const age=button.dataset.bbAge;filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;this.querySelectorAll('[data-bb-card]').forEach(card=>{const visible=age==='all'||(Number(age)>=Number(card.dataset.min)&&Number(age)<=Number(card.dataset.max));card.hidden=!visible;if(visible)count++;});const empty=this.querySelector('[data-bb-empty]');if(empty)empty.hidden=count>0;const status=this.querySelector('[data-bb-count]');if(status)status.textContent=count+' univers affiché'+(count>1?'s':'')+'.';},{signal:this.controller.signal});}disconnectedCallback(){this.controller?.abort();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bibouche-univers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bibouche-univers-v2')) {
  customElements.define('bibouche-univers-v2', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const filters = this.querySelector('[data-bb-filters]'); if (!filters) return;
      filters.hidden = false;
      const apply = (age) => {
        let count = 0;
        filters.querySelectorAll('button[data-bb-age]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bbAge === age)));
        this.querySelectorAll('[data-bb-card]').forEach(card => {
          const visible = age === 'all' || (Number(age) >= Number(card.dataset.min) && Number(age) <= Number(card.dataset.max));
          card.hidden = !visible; if (visible) count++;
        });
        const empty = this.querySelector('[data-bb-empty]'); if (empty) empty.hidden = count > 0;
        const status = this.querySelector('[data-bb-count]'); if (status) status.textContent = (count === 1 ? this.dataset.resultOne : this.dataset.resultMany).replace('__COUNT__', String(count));
        document.querySelectorAll('[data-bb-choose-age]').forEach(link => { if (link.dataset.bbCatalog === this.parentElement.id) link.setAttribute('aria-current', String(link.dataset.bbChooseAge === age)); });
      };
      filters.addEventListener('click', event => {
        const button = event.target.closest('button[data-bb-age]'); if (button && filters.contains(button)) apply(button.dataset.bbAge);
      }, {signal: this.controller.signal});
      document.addEventListener('click', event => {
        const link = event.target.closest('a[data-bb-choose-age]');
        if (!link || link.dataset.bbCatalog !== this.parentElement.id) return;
        event.preventDefault(); apply(link.dataset.bbChooseAge);
        this.parentElement.scrollIntoView({block:'start',behavior:'instant'});
        const heading = this.parentElement.querySelector('h2');
        if (heading) { heading.tabIndex = -1; heading.focus({preventScroll:true}); }
      }, {signal:this.controller.signal});
      this.addEventListener('shopify:block:select', () => apply('all'), {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
